var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 110,
    viewBox: "0 0 112 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3466128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3466125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40695",
    x: 1.24434,
    y: 1.24434,
    width: 55.2489,
    height: 107.511,
    rx: 6.71946,
    stroke: "#FAFAFA",
    strokeWidth: 2.48869
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40696",
    x: 13.9375,
    width: 29.8643,
    height: 7.9638,
    rx: 2.48869,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3466126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40695_2",
    d: "M64.9548 50.7656L102.036 50.7656C106.434 50.7656 110 54.3311 110 58.7294L110 100.539C110 104.938 106.434 108.503 102.036 108.503L62.9638 108.503",
    stroke: "#FAFAFA",
    strokeWidth: 2.48869,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40696_2",
    x: 110,
    y: 64.7031,
    width: 29.8643,
    height: 7.9638,
    rx: 2.48869,
    transform: "rotate(90 110 64.7031)",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3466127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 167",
    d: "M66.1992 12.4453H68.1902C84.6837 12.4453 98.0544 25.816 98.0544 42.3096V42.3096",
    stroke: "#FAFAFA",
    strokeWidth: 2.48869
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 168",
    d: "M72.422 5.97656L65.5113 11.9956C65.0763 12.3744 65.0533 13.0423 65.4612 13.4501L71.9242 19.9132",
    stroke: "#FAFAFA",
    strokeWidth: 2.48869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 169",
    d: "M104.416 35.4002L99.4238 43.0858C99.1096 43.5695 98.4515 43.6858 97.9906 43.3391L90.686 37.845",
    stroke: "#FAFAFA",
    strokeWidth: 2.48869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateIcon);
export default __webpack_public_path__ + "static/media/rotate-icon.e8cf11dcc0f603276de6c8c80a77d916.svg";
export { ForwardRef as ReactComponent };